import {
  HStack,
  VStack,
  Heading,
  Text,
  CircleExclamationMarkIcon,
} from '@frontend/components';

type WarningExplanationProps = {
  title: string;
  description: string;
};

export const WarningExplanation = ({
  title,
  description,
}: WarningExplanationProps) => {
  return (
    <HStack align="flex-start" py={0.5}>
      <CircleExclamationMarkIcon color="alert.warning" boxSize={3} />
      <VStack spacing={0} align="stretch">
        <Heading size="md" fontWeight="bold">
          {title}
        </Heading>
        <Text>{description}</Text>
      </VStack>
    </HStack>
  );
};
